import { deriveResource } from 'pulse/resources';
import { keyBy } from '../../utils/keyBy';
import { PropertyGroups } from '../PropertyGroups';
import { stringCollator } from '../../utils/stringCollator';
import { propertiesIdentity } from '../PropertyGroups/entity';
export const PropertyDefinitions = deriveResource('hs-entities:PropertyDefinitions').from(PropertyGroups).pull(({
  other
}) => other.data.flatMap(group => {
  var _group$propertyDefini;
  return (_group$propertyDefini = group.propertyDefinitions) !== null && _group$propertyDefini !== void 0 ? _group$propertyDefini : [];
}).sort((a, b) => stringCollator.compare(a.property.label || a.property.name, b.property.label || b.property.name))).push(({
  self,
  other
}) => {
  if (!other.data) {
    return;
  }
  const propertiesMap = keyBy(self.data, definition => definition.property.groupName, (definition, __index, props = []) => {
    props.push(definition);
    return props;
  });
  return other.data.map(group => Object.assign({}, group, {
    propertyDefinitions: propertiesMap[group.name]
  }));
}).withIdentity(propertiesIdentity).register();
export const PropertyDefinitionsMap = deriveResource('hs-entities:PropertyDefinitionsMap').from(PropertyDefinitions).pull(({
  other
}) => keyBy(other.data, definition => definition.property.name)).push(({
  self
}) => Object.values(self.data)).withIdentity(propertiesIdentity).register();
export const PropertyDefinition = deriveResource('hs-entities:PropertyDefinition').from(PropertyDefinitionsMap).mapParams(({
  objectTypeId,
  showHighlySensitiveProperties
}) => ({
  objectTypeId,
  showHighlySensitiveProperties
})).pull(({
  self,
  other
}) => {
  const property = other.data[self.params.propertyName];
  if (!property) {
    throw new Error(`Property ${self.params.propertyName} not found`);
  }
  return property;
}).push(({
  self,
  other
}) => other.data && Object.assign({}, other.data, {
  [self.params.propertyName]: self.data
})).withIdentity(params => `${propertiesIdentity(params)}-propertyName:${params.propertyName}`).register();